import React from 'react';
import { CircularProgressIndicator } from '../components/CircularProgressIndicator';
import { SingleWrapper } from '../components/SimpleWrapper';

export const HocWithPreloader = ({
  isLoading = false,
  children,
  data,
  emptyText = '',
  withContainer = false,
}) => {
  if (isLoading) return <CircularProgressIndicator />;

  // if ((Array.isArray(data) && !data?.length) || !Object.keys(data).length)
  //   return (
  //     emptyText && (
  //       <SingleWrapper
  //         className={withContainer ? 'container main-padding-block-one' : ''}
  //       >
  //         <p className="subscription__none-title">{emptyText}</p>
  //       </SingleWrapper>
  //     )
  //   );
  if (typeof children === 'function') return children(data);
  return children;
};
